<template>
    <button-game name="logar com o facebook" typeLogin="social" social="facebook" action="facebook"></button-game>
</template>
<script>
import ButtonGame from './ButtonGame'
import Bus from '@/main.js'
import firebase from "firebase";
export default {
    components: {
        ButtonGame
    },
    created(){
        Bus.$on('facebook', this.authFacebook)
    },
    methods: {
        authFacebook(boolean){
            let self = this
            var provider = new firebase.auth.FacebookAuthProvider();
            firebase.auth().signInWithPopup(provider).then(function(result) {
                // This gives you a Facebook Access Token. You can use it to access the Facebook API.
                var token = result.credential.accessToken;
                // The signed-in user info.
                var user = result.user;
                self.$router.push('/middleware-game')
                // ...
                }).catch(function(error) {
                    alert(error.message)
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                // The email of the user's account used.
                var email = error.email;
                // The firebase.auth.AuthCredential type that was used.
                var credential = error.credential;
                // ...
            });
        }
    }
}
</script>